import { Component, Input } from '@angular/core';
import { keysToTranslate } from 'i18n/keys-to-translate';
import { GlaeubigerVersionDetailEntryMeta, PfandrechtMasterDetailEntryMeta } from '../../../../core/gb-api';
import { TranslatePipe } from '@ngx-translate/core';
import { HistoryDirective } from '../../../../shared/directives/history.directive';
import { KompaktPersongbComponent } from '../../../../shared/kompaktdarstellung/persongb/kompakt-persongb.component';
import { KompaktTimepointComponent } from '../../../../shared/kompaktdarstellung/timepoint/kompakt-timepoint.component';
import { RechtsgrundComponent } from '../../../../shared/kompaktdarstellung/rechtsgrund/rechtsgrund.component';
import { NgTemplateOutlet } from '@angular/common';
import { GlaeubigerRolleCodePipe } from '../../../../shared/pipes/simple/glaeubiger-rolle-code.pipe';
import GlaeubigerrolleEnum = GlaeubigerVersionDetailEntryMeta.GlaeubigerrolleEnum;

@Component({
  selector: 'cap-pfandrecht-glaeubiger',
  templateUrl: './pfandrecht-glaeubiger.component.html',
  styleUrls: ['./pfandrecht-glaeubiger.component.scss'],
  imports: [
    TranslatePipe,
    HistoryDirective,
    KompaktPersongbComponent,
    KompaktTimepointComponent,
    RechtsgrundComponent,
    NgTemplateOutlet,
    GlaeubigerRolleCodePipe
  ]
})
export class PfandrechtGlaeubigerComponent {
  @Input()
  recht: PfandrechtMasterDetailEntryMeta;

  constructor() {
    keysToTranslate<GlaeubigerrolleEnum>(['GRUNDPFANDGLAEUBIGER', 'FAUSTPFANDGLAEUBIGER', 'NUTZNIESSER', 'ANDEREROLLE']);
  }
}
